import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { LocalService } from '../../storage/localService';
import { filter, pluck, map } from 'rxjs/operators';
import { SessionStorageService } from '../../storage/sessionStorage.service';
import { Observable } from 'rxjs';

export const SERVIFIN_CREDITO_PDF_TIPOS = [
  'tabla_amortizacion', 'estado_cuenta', 'operacion_vigente',
  'liquidacion_credito', 'recibo_caja', 'factura_intereses',
];

export const SERVIFIN_DOCUMENTO_PDF_TIPOS = [
  'orden_operacion', 'factura_comision_fex', 'nota_cartera_ncl',
  'propuesta_comprador', 'confirmacion_comprador', 'extracto_cartera_comprador',
  'pago_global_cliente', 'causacion_rendimientos',
];

@Injectable({ providedIn: 'root' })
export class ServifinPdfService {
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  idEmpresa_Factor: any;
  message: Observable<any>;

  constructor(
    private http: HttpClient,
    private accesoService: AccesoService,
    private sessionStorageService: SessionStorageService,
    private localService: LocalService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === 'sessionStorage'),
      filter(({ key }) => key === '1cefada07eb9'),
      pluck('value')
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'));
    if (this.idEmpresa_Factor === undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom');
    }
  }

  generarPdf(payload: any, tipo: string): Observable<Blob> {
    const body = Object.assign({}, payload, { tipo });
    const url = SERVIFIN_CREDITO_PDF_TIPOS.indexOf(tipo) >= 0
      ? `${this.urlBase}/CreditoServifinPdf?idEmpresa_Factor=${this.idEmpresa_Factor}`
      : `${this.urlBase}/ServifinPdf?idEmpresa_Factor=${this.idEmpresa_Factor}`;
    return this.http.post(url, body, { headers: this.header }).pipe(
      map((res: any) => this.blobFromResponse(res))
    );
  }

  generarPdfOrdenOperacion(idSolicitudDesembolso: number, idOperacion: number): Observable<Blob> {
    return this.http.post(
      `${this.urlBase}/ServifinPdfOrdenOperacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,
      { idSolicitudDesembolso, idOperacion },
      { headers: this.header }
    ).pipe(map((res: any) => this.blobFromResponse(res)));
  }

  descargarBlob(blob: Blob, nombre: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  private blobFromResponse(res: any): Blob {
    const data = res.data || res;
    const b64 = data.pdf_base64;
    const raw = atob(b64);
    const arr = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      arr[i] = raw.charCodeAt(i);
    }
    return new Blob([arr], { type: 'application/pdf' });
  }
}
